var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-tab-pane", { attrs: { name: "general" } }, [
    _c("div", { staticClass: "row gutter-x-md justify-start" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("logo")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("logo_hover")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c(
            "image-input",
            {
              attrs: {
                uploadEndpoint: _vm.storeLogo,
                deleteEndpoint: _vm.deleteLogo,
                imageUrl: _vm.teamLogo,
                imageType: _vm.$t("logo")
              }
            },
            [
              _c("team-logo", {
                staticClass: "q-display-3",
                attrs: {
                  slot: "placeholder",
                  team: _vm.team,
                  height: "160px",
                  width: "160px"
                },
                slot: "placeholder"
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("hr"),
    _c("div", { staticClass: "row gutter-x-md" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$tc("team")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("team_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("team_name"),
                labelWidth: 3,
                error: _vm.errors.has("name"),
                "error-label": _vm.errors.first("name")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|min:1|max:255",
                    expression: "'required|min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "name",
                  "data-vv-as": _vm.$t("team_name"),
                  placeholder: _vm.$t("team_name")
                },
                model: {
                  value: _vm.formData.name,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "name", $$v)
                  },
                  expression: "formData.name"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("legal_form"),
                labelWidth: 3,
                error: _vm.errors.has("legal_form"),
                "error-label": _vm.errors.first("legal_form")
              }
            },
            [
              _c("q-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  options: _vm.legalFormOptions,
                  name: "legal_form",
                  "data-vv-as": _vm.$t("legal_form"),
                  placeholder: _vm.$t("legal_form")
                },
                model: {
                  value: _vm.formData.legalForm,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "legalForm", $$v)
                  },
                  expression: "formData.legalForm"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("tax_number"),
                labelWidth: 3,
                error: _vm.errors.has("tax_number"),
                "error-label": _vm.errors.first("tax_number")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "min:1|max:255",
                    expression: "'min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "tax_number",
                  "data-vv-as": _vm.$t("tax_number"),
                  placeholder: _vm.$t("tax_number")
                },
                model: {
                  value: _vm.formData.taxNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "taxNumber", $$v)
                  },
                  expression: "formData.taxNumber"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("vat_number"),
                labelWidth: 3,
                error: _vm.errors.has("vat_number"),
                "error-label": _vm.errors.first("vat_number")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "min:1|max:255",
                    expression: "'min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "vat_number",
                  "data-vv-as": _vm.$t("vat_number"),
                  placeholder: _vm.$t("vat_number")
                },
                model: {
                  value: _vm.formData.vatNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "vatNumber", $$v)
                  },
                  expression: "formData.vatNumber"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("registration_number"),
                labelWidth: 3,
                error: _vm.errors.has("registration_number"),
                "error-label": _vm.errors.first("registration_number")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "min:1|max:255",
                    expression: "'min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "registration_number",
                  "data-vv-as": _vm.$t("registration_number"),
                  placeholder: _vm.$t("registration_number")
                },
                model: {
                  value: _vm.formData.registrationNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "registrationNumber", $$v)
                  },
                  expression: "formData.registrationNumber"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            {
              attrs: {
                label: _vm.$t("registration_court"),
                labelWidth: 3,
                error: _vm.errors.has("registration_court"),
                "error-label": _vm.errors.first("registration_court")
              }
            },
            [
              _c("q-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "min:1|max:255",
                    expression: "'min:1|max:255'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  name: "registration_court",
                  "data-vv-as": _vm.$t("registration_court"),
                  placeholder: _vm.$t("registration_court")
                },
                model: {
                  value: _vm.formData.registrationCourt,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "registrationCourt", $$v)
                  },
                  expression: "formData.registrationCourt"
                }
              })
            ],
            1
          ),
          _c(
            "q-field",
            { attrs: { label: _vm.$t("managers"), labelWidth: 3 } },
            [
              _c("q-chips-input", {
                ref: "managerInput",
                attrs: {
                  name: "managers",
                  "add-icon": "add",
                  placeholder: _vm.$t("managers")
                },
                on: { blur: _vm.handleManagerBlur },
                model: {
                  value: _vm.formData.managers,
                  callback: function($$v) {
                    _vm.$set(_vm.formData, "managers", $$v)
                  },
                  expression: "formData.managers"
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _c("hr"),
    _c("div", { staticClass: "row gutter-x-md" }, [
      _c("div", { staticClass: "col-md-3 col-12" }, [
        _c("h6", { staticClass: "q-mt-md q-mb-sm q-title" }, [
          _vm._v(_vm._s(_vm.$t("language")))
        ]),
        _c("p", { staticClass: "text-faded" }, [
          _vm._v(_vm._s(_vm.$t("language_hint")))
        ])
      ]),
      _c(
        "div",
        { staticClass: "col-md-9 col-12" },
        [
          _c("language-input", {
            attrs: { labelWidth: 3 },
            model: {
              value: _vm.formData.language,
              callback: function($$v) {
                _vm.$set(_vm.formData, "language", $$v)
              },
              expression: "formData.language"
            }
          }),
          _c(
            "q-field",
            [
              _c(
                "q-checkbox",
                {
                  attrs: {
                    label: _vm.$t("small_business"),
                    disable: _vm.team.isSubscribedToStudentPlan()
                  },
                  model: {
                    value: _vm.formData.isSmallBusiness,
                    callback: function($$v) {
                      _vm.$set(_vm.formData, "isSmallBusiness", $$v)
                    },
                    expression: "formData.isSmallBusiness"
                  }
                },
                [
                  _vm.team.isSubscribedToStudentPlan()
                    ? _c("q-tooltip", [
                        _vm._v(_vm._s(_vm.$t("small_business_info_student")))
                      ])
                    : _vm._e()
                ],
                1
              ),
              _c(
                "q-icon",
                {
                  staticClass: "on-right",
                  attrs: { name: "info", color: "faded" }
                },
                [
                  _c("q-tooltip", [
                    _vm._v(_vm._s(_vm.$t("small_business_info")))
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]),
    _c(
      "div",
      { staticClass: "row justify-end" },
      [
        _c(
          "q-btn",
          {
            attrs: { type: "submit", color: "primary" },
            on: { click: _vm.handleSave }
          },
          [_vm._v(_vm._s(_vm.$t("save")))]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }